import { styled } from 'stitches.config'
import { HeaderRoot } from 'components/Header/Header.styles'

export const MealPlanRoot = styled('div', {
  [`& ${HeaderRoot}`]: {
    position: 'static',
  },
})

export const ContentWrapper = styled('div', {})

export const MaxSize = styled('div', {
  maxWidth: '$max',
  margin: 'auto',
  variants: {
    width: {
      full: {
        maxWidth: '100%',
      },
    },
  },
})

export const MealPlanQuestionnaireCard = styled('div', {
  padding: '$5 0',
  paddingBottom: '$4',

  '@bp2': {
    px: '$10',
    py: '$7',
  },
})

export const MealPlanFormContainer = styled('div', {
  width: '100%',
  maxWidth: '361px',
  margin: 'auto',
  '@bp2': {
    maxWidth: '462px',
  },
})
